export default "__VITE_ASSET__BCy0gfQE__"